/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Messages_Move_UpInputs */

const cs_messages_move_up = /** @type {(inputs: Messages_Move_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posunout nahoru`)
};

const en_messages_move_up = /** @type {(inputs: Messages_Move_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Move up`)
};

/**
* | output |
* | --- |
* | "Move up" |
*
* @param {Messages_Move_UpInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const messages_move_up = /** @type {((inputs?: Messages_Move_UpInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Messages_Move_UpInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_messages_move_up(inputs)
	return cs_messages_move_up(inputs)
});